import './index.css';
import { Container } from '@mui/material';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import MenuScreen from './screens/MenuScreen';
import CheckoutScreen from './screens/CheckoutScreen';
import DeliverySelectionScreen from './screens/AddressSelectionScreen';
import PhoneConfirmationScreen from './screens/PhoneConfirmationScreen';
import appRoutes from './utils/routes';
import OrderStatusScreen from './screens/OrderStatusScreen';
import TableSelectionScreen from './screens/TableSelectionScreen';
import NotFoundScreen from './screens/NotFoundScreen';
import StartScreen from './screens/StartScreen';

function App() {
  return (
    <Container
      maxWidth="sm"
      sx={{
        backgroundColor: '#F7F7F7',
        padding: '16px 24px 0 24px'
      }}
    >
        <BrowserRouter>
          <Routes>
            <Route path={appRoutes.start} Component={StartScreen } />
            <Route path={appRoutes.menu} Component={MenuScreen} />
            <Route path={appRoutes.checkout} Component={CheckoutScreen} />
            <Route path={appRoutes.address} Component={DeliverySelectionScreen} />
            <Route path={appRoutes.phone} Component={PhoneConfirmationScreen} />
            <Route path={appRoutes.orderStatus} Component={OrderStatusScreen} />
            <Route path={appRoutes.table} Component={TableSelectionScreen} />
            <Route path="*" Component={NotFoundScreen} />
          </Routes>
        </BrowserRouter>
    </Container>
  );
}

export default App;
